import { getCurrentEnv } from './getCurrentEnv';

/**
 * generates the base api url based on a path and and an env.
 * If not env is provided, defaults to the window.location.host
 */
export function generateBaseApiUrl(
  path: string,
  currentEnv: string = getCurrentEnv(window.location.host)
) {
  const newPath =
    currentEnv === 'prod'
      ? `https://api.inpay.com${path}`
      : `https://${currentEnv}-api.inpay.com${path}`;

  return (
    newPath
      // Remove one occurrence of `/api` if it appears right after domain
      .replace(/(https:\/\/[^\/]+)\/api/, '$1')
      .replace('/customer_app_api', '')
  );
}
